import React, { useState } from 'react';

function PrivacyPolicy() {
  const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = (sectionId) => {
    if (expandedSection === sectionId) {
      setExpandedSection(null);
    } else {
      setExpandedSection(sectionId);
    }
  };

  // Policy section data
  const sections = [
    {
      id: 1,
      title: "Information We Collect",
      icon: "👤",
      content: (
        <>
          <p>We may collect personal information that you provide directly to us when you:</p>
          <ul>
            <li>Register or create an account</li>
            <li>Book an appointment</li>
            <li>Contact us via forms or email</li>
            <li>Use our consultation services</li>
          </ul>
          <p>This may include:</p>
          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Date of birth</li>
            <li>Medical history or health-related information</li>
          </ul>
        </>
      )
    },
    {
      id: 2,
      title: "How We Use Your Information",
      icon: "📊",
      content: (
        <>
          <p>We use the collected data to:</p>
          <ul>
            <li>Provide and manage appointments and consultations</li>
            <li>Personalize user experience</li>
            <li>Improve our website and services</li>
            <li>Communicate with users (appointment reminders, updates, etc.)</li>
            <li>Comply with legal obligations</li>
          </ul>
        </>
      )
    },
    {
      id: 3,
      title: "Sharing Your Information",
      icon: "🔄",
      content: (
        <>
          <p>We do not sell your personal data. We may share it with:</p>
          <ul>
            <li>Dermatology professionals for consultation purposes</li>
            <li>Payment processors for secure transactions</li>
            <li>Third-party services that help operate our platform (under strict confidentiality)</li>
            <li>Legal authorities if required by law</li>
          </ul>
        </>
      )
    },
    {
      id: 4,
      title: "Data Security",
      icon: "🔒",
      content: (
        <p>We implement reasonable administrative and technical safeguards to protect your data. However, no system is completely secure. Use the platform at your own discretion.</p>
      )
    },
    {
      id: 5,
      title: "Cookies and Tracking Technologies",
      icon: "🌐",
      content: (
        <p>We may use cookies and similar technologies to improve your browsing experience. You can control cookie preferences via your browser settings.</p>
      )
    },
    {
      id: 6,
      title: "Your Rights",
      icon: "📝",
      content: (
        <>
          <p>Depending on your region, you may have rights to:</p>
          <ul>
            <li>Access the personal information we hold</li>
            <li>Correct or delete your data</li>
            <li>Withdraw consent at any time</li>
            <li>Lodge a complaint with a data protection authority</li>
          </ul>
        </>
      )
    },
    {
      id: 7,
      title: "Third-Party Links",
      icon: "🔗",
      content: (
        <p>Our website may contain links to external websites. We are not responsible for the content or privacy practices of those websites.</p>
      )
    }
  ];

  return (
    <div className="privacy-policy">
      <style>
        {`
          /* Privacy Policy Component Styles */
          .privacy-policy {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            line-height: 1.6;
            color: #333;
            background: linear-gradient(to bottom, #f0f7ff, #ffffff);
            min-height: 100vh;
            padding: 0;
            margin: 0;
          }
          
          .privacy-container {
            max-width: 1000px;
            margin: 0 auto;
            padding: 40px 20px;
          }
          
          .privacy-header {
            text-align: center;
            margin-bottom: 40px;
          }
          
          .privacy-icon {
            font-size: 48px;
            margin-bottom: 15px;
            color: #3366cc;
          }
          
          .privacy-title {
            font-size: 32px;
            font-weight: bold;
            color: #333;
            margin-bottom: 8px;
          }
          
          .privacy-subtitle {
            font-size: 20px;
            color: #3366cc;
            font-weight: 500;
          }
          
          .privacy-intro {
            background-color: white;
            border-radius: 12px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            padding: 24px;
            margin-bottom: 30px;
          }
          
          .privacy-intro p {
            font-size: 18px;
            line-height: 1.6;
          }
          
          .privacy-search {
            background-color: white;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            padding: 12px 16px;
            display: flex;
            align-items: center;
            margin-bottom: 24px;
            position: sticky;
            top: 16px;
            z-index: 10;
          }
          
          .search-icon {
            margin-right: 8px;
            color: #999;
          }
          
          .privacy-search input {
            width: 100%;
            border: none;
            font-size: 16px;
            padding: 8px 0;
            background: transparent;
          }
          
          .privacy-search input:focus {
            outline: none;
          }
          
          .privacy-section {
            background-color: white;
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            overflow: hidden;
            margin-bottom: 16px;
            transition: all 0.3s ease;
          }
          
          .section-header {
            padding: 20px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          
          .section-title {
            font-size: 18px;
            font-weight: 600;
            color: #333;
            display: flex;
            align-items: center;
          }
          
          .section-icon {
            margin-right: 12px;
            color: #3366cc;
            font-size: 20px;
          }
          
          .arrow-icon {
            font-size: 12px;
            color: #999;
            transition: transform 0.3s ease;
          }
          
          .arrow-icon.open {
            transform: rotate(180deg);
            color: #3366cc;
          }
          
          .section-content {
            padding: 0 20px 20px;
            border-top: 1px solid #f0f0f0;
          }
          
          .section-content p {
            margin-bottom: 16px;
            line-height: 1.6;
          }
          
          .section-content ul {
            list-style-type: disc;
            padding-left: 24px;
            margin-bottom: 16px;
          }
          
          .section-content li {
            margin-bottom: 8px;
            line-height: 1.5;
          }
          
          .privacy-footer {
            text-align: center;
            color: #777;
            font-size: 14px;
            margin-top: 40px;
          }
          
          .privacy-footer p {
            margin-bottom: 8px;
          }
          
          /* Responsive styles */
          @media (max-width: 768px) {
            .privacy-container {
              padding: 20px 16px;
            }
            
            .privacy-title {
              font-size: 28px;
            }
            
            .privacy-intro p {
              font-size: 16px;
            }
            
            .section-header {
              padding: 16px;
            }
          }
          
          @media (max-width: 480px) {
            .privacy-icon {
              font-size: 36px;
            }
            
            .privacy-title {
              font-size: 24px;
            }
            
            .privacy-subtitle {
              font-size: 18px;
            }
            
            .section-title {
              font-size: 16px;
            }
          }
        `}
      </style>
      
      <div className="privacy-container">
        <header className="privacy-header">
          <div className="privacy-icon">🛡️</div>
          <h1 className="privacy-title">Privacy Policy</h1>
          <h2 className="privacy-subtitle">DermaConsult.online</h2>
        </header>
        
        <div className="privacy-intro">
          <p>
            At DermaConsult.online, your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our dermatology consultation services.
          </p>
        </div>
        
        <div className="privacy-search">
          <span className="search-icon">🔍</span>
          <input 
            type="text" 
            placeholder="Search privacy policy..." 
          />
        </div>
        
        <div className="privacy-sections">
          {sections.map((section) => (
            <div className="privacy-section" key={section.id}>
              <div 
                className="section-header" 
                onClick={() => toggleSection(section.id)}
              >
                <h3 className="section-title">
                  <span className="section-icon">{section.icon}</span>
                  {section.title}
                </h3>
                <span className={`arrow-icon ${expandedSection === section.id ? 'open' : ''}`}>
                  ▼
                </span>
              </div>
              
              {expandedSection === section.id && (
                <div className="section-content">
                  {section.content}
                </div>
              )}
            </div>
          ))}
        </div>
        
        <footer className="privacy-footer">
          <p>Last updated: May 2025</p>
        </footer>
      </div>
    </div>
  );
}

export default PrivacyPolicy;